import { useCallback, useState } from 'react';
import { useWidget } from '../context/WidgetContext.js';
import { AvatarImage } from './Avatar.js';
import { IconChat } from './icons.js';

type LauncherButtonProps = {
  unreadCount?: number;
  onClick: () => void;
  compact?: boolean;
  ariaLabel?: string;
};

export function LauncherButton({
  unreadCount = 0,
  onClick,
  compact = false,
  ariaLabel = 'Open chat',
}: LauncherButtonProps) {
  const { settings } = useWidget();
  const avatarUrl = settings.content.aiAvatarUrl?.trim() || null;
  const [avatarFailed, setAvatarFailed] = useState(false);
  const onAvatarError = useCallback(() => setAvatarFailed(true), []);
  const showAvatar = Boolean(avatarUrl) && !avatarFailed;

  return (
    <button
      type="button"
      className={`teo-launcher${showAvatar ? ' teo-launcher--avatar' : ''}${compact ? ' teo-launcher--compact' : ''}`}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      {showAvatar ? (
        <span className="teo-launcher__avatar-wrap" aria-hidden>
          <AvatarImage
            className="teo-launcher__avatar"
            src={avatarUrl!}
            onError={onAvatarError}
          />
        </span>
      ) : (
        <IconChat size={26} />
      )}
      <span className="teo-launcher__online" aria-hidden />
      {unreadCount > 0 && (
        <span className="teo-launcher__badge" aria-label={`${unreadCount} unread`}>
          {unreadCount > 9 ? '9+' : unreadCount}
        </span>
      )}
    </button>
  );
}
